<template>
    <div>
        <b-form-group
            :invalid-feedback="error"
            :label="__(config.name, ['titleCase'])">
            <small v-if="config.description" class="form-text mb-2">{{ config.description }}</small>
            <input :type="showPassword ? 'text' : 'password'"
                v-on:input="(e) => onChange(e.target.value)"
                :value="value"
                :tabindex="position"
                class="form-control" />
            <button type="button"
                v-on:click="generatePassword"
                class="btn btn-sm btn-rounded btn-success mt-2">Generate password</button>
            <button type="button"
                v-on:click="toggleShowPassword"
                class="btn btn-sm btn-rounded btn-default mt-2">
                <input type="checkbox" v-model="showPassword" class="mr-1">Show password</button>
        </b-form-group>
        <b-form-group
            :label="'Confirm ' + __(config.name, ['titleCase'])">
            <input type="password"
                v-on:input="(e) => checkConfirm(e.target.value)"
                v-model="confirm"
                :tabindex="position + 1"
                class="form-control" />
        </b-form-group>
    </div>
</template>
<script>
import Vue from 'vue';
import V from 'voca';

export default {
    data() {
        return {
            showPassword: false,
            confirm: '',
            dirty: false,
            isMatch: true,
        }
    },

    props: ['value', 'label', 'position', 'required', 'state', 'error', 'config', 'timestamp'],

    computed: {

    },

    watch: {
        value(newVal) {
            if (!newVal) {
                this.$emit('input', null);
            }
        },
    },

    methods: {
        onChange(value) {
            this.isMatch = value == this.confirm;
            this.$emit('error', { password: this.isMatch ? null : 'Password not match' });
            return this.$emit('input', value);
        },

        checkConfirm(value) {
            this.isMatch = value == this.value;
            this.$emit('error', { password: this.isMatch ? null : 'Password not match' });
        },

        toggleShowPassword() {
            this.showPassword = !this.showPassword;
        },

        generatePassword() {
            let length = 8;
            let charset = "abcdefghijklmnopqrstuvwxyz0123456789";
            let uppercaseCharset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
            let specialCharset = "~!@#$%^&*_-=+"

            let password = _.chain([])
                .concat(this.pickChars(charset, 5))
                .concat(this.pickChars(uppercaseCharset, 2))
                .concat(this.pickChars(specialCharset, 1))
                .shuffle()
                .join('')
                .value();

            this.showPassword = true;
            this.$emit('input', password);
            this.confirm = password;
        },

        pickChars(charset, number) {
            let chars = [];
            for (var i = 0, n = charset.length; i < number; ++i) {
                chars.push(charset.charAt(Math.floor(Math.random() * n)));
            }

            return chars;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/PasswordConfirmComponent.vue